$(document).on('appReady', () => {
  $('.js__imagePreloader').find('link').each((_, el) => {
    const $link = $(el)

    $link.attr('href', $link.attr('data-href'))
    $link.attr('rel', 'preload')
  })
})
